module.exports = __webpack_public_path__ + "static/img/zijian3.886c8c40.png";